import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import helpicon from "../images/Vector (3).png";
import axios from 'axios';
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { api_url } from "../config/config";
import { toast } from 'react-toastify';


const Orderdetails = ({ getOrder }) => {

  const { order_id } = useParams();
  const [isCancelled, setIsCancelled] = useState(false);
  const [isOrderCancelled, setIsOrderCancelled] = useState(false);
  const [selectedReason, setSelectedReason] = useState('');
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState([]);
  const [productImage, setProductImage] = useState({});
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cancellationError, setCancellationError] = useState(null);
  const token = localStorage.getItem("authToken");
  const location = useLocation();
  const [availableStatuses, setAvailableStatuses] = useState([
    "ORDER_PLACED",
    "ORDER_PROCESSING",
    "OUT_FOR_DELIVERY",
    "DELIVERED"
  ]);
  const { orderDetails } = location.state || {}; 

  const navigate = useNavigate();




  // const handleSubmit = () => navigate('/orderdetails', { state: { reason: selectedReason } });

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const handleReasonChange = (event) => setSelectedReason(event.target.value);

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);



  const reasons = [
    "I want to modify Items in my order",
    "Bought Items from outside",
    "Delay in order",
    "Forgot to apply coupon",
    "Facing Payment Related issues",
    "Wallet Balance Issue",
    "Incorrect address",
    "Other"
  ];




  const fetchUpdateStatus = async () => {
    if(!selectedReason){
      setCancellationError("Please select a reason for cancellation.");
      return;
    };
    try {
      const { data } = await axios.patch(
        `${api_url}/order/${orderDetails.razorpay_order_id}`,
        {
          previous_status: order.delivery_status, 
          delivery_status: 'CANCELLED',
          reason: selectedReason
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      setIsModalOpen(false);
      setOrder((prevOrder) => ({
        ...prevOrder,
        delivery_status: 'CANCELLED',
        previous_status: data.previous_status,
        cancellation_reason: data.cancellation_reason || selectedReason
      }));
      setIsOrderCancelled(true);
    } catch (e) {
      console.error("Error updating status:", e.response ? e.response.data : e.message);
    }
  };







  useEffect(() => {
    const fetchOrder = async () => {
     
      try {
        const response = await axios.get(
          `${api_url}/order/${orderDetails.razorpay_order_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
 
        if (response.data?.data && response.data.data.delivery_status !== order?.delivery_status) {
          setOrder(response.data.data);
          if (response.data.data.delivery_status === "CANCELLED") {
            // setIsCancelled(true);
          }
        }
      } catch (error) {
        console.error("Error fetching order:", error);
      }
    };

    fetchOrder();
  }, []);

  useEffect(() => {
    if (order?.delivery_status && !availableStatuses.includes(order.delivery_status)) {
      setAvailableStatuses(prevStatuses => [...prevStatuses, order.delivery_status]);
    }
  }, [order?.delivery_status]);





  // // const displayedStatuses = availableStatuses;
  // const displayedStatuses = availableStatuses.filter(status => status !== "CANCELLED");
  const logicalStatuses = [...availableStatuses];
const displayedStatuses = order?.delivery_status === "CANCELLED"
  ? logicalStatuses.filter(status => status !== "CANCELLED")
  : logicalStatuses;

let lastStepIndex = displayedStatuses.indexOf(order?.delivery_status);

if (order?.delivery_status === "CANCELLED" && order?.previous_status) {
  lastStepIndex = displayedStatuses.indexOf(order.previous_status);
}

const cancelled = order?.delivery_status === "CANCELLED";
const cancelledAtStatus = cancelled
  ? order?.previous_status?.[order.previous_status.lastIndexOf("CANCELLED") - 1]
  : null;
const cancelledIndex = displayedStatuses.findIndex(status => status === cancelledAtStatus);

if (lastStepIndex === -1) lastStepIndex = 0; 
  const isCompletedStep = (index) => {
    if (order?.delivery_status === "CANCELLED") {
      return index < lastStepIndex; 
    }
    return index <= lastStepIndex;
  };




  const handleclickforfeaturedproduct = async (product_id, product_name) => {
    try {
        const response = await fetch(`${api_url}/product/${product_id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('authToken'),
                'x-auth': false
            }
        });
        const data = await response.json();
        if (data.error && data.message === 'No product details found') {
            toast.error('This Product is not available.');
            return;
        }
        navigate(`/products/${product_name?.toLowerCase().replace(/\s+/g, '-')}`, {
            state: { product_id },
        });
    } catch (err) {
        toast.error('Error Occured. Please try again.');
    }
};

  const ItemCard = () => {
    const products = (Array.isArray(order?.product) && order.product.length)
      ? order.product
      : (orderDetails?.details?.[0]?.product || []);
    if (!Array.isArray(products) || products.length === 0) {
      return <p className="text-gray-500">No orders available</p>;
    }

    const getPrimaryImageUrl = (item) => {
      const objUrl = item?.variant?.product?.product_images?.image_url?.primary_image;
      if (objUrl) return objUrl;
      const arrUrl = item?.variant?.product?.product_images?.[0]?.image_url?.primary_image;
      return arrUrl || "https://via.placeholder.com/150";
    };

    return (
      <div>
        {products.map((item, index) => (
          <Link
            key={index}
            to="#"
            onClick={(e) => {
              e.preventDefault();
              handleclickforfeaturedproduct(item.product_id,item.variant?.product?.name)
            }}
            className="border p-4 rounded-lg mb-4 flex"
          >
            <img
              src={getPrimaryImageUrl(item)}
              alt={item?.variant?.product?.name || "Product Image"}
              className="w-16 h-16 object-cover mr-4"
              onError={(e) => { e.currentTarget.src = "https://via.placeholder.com/150"; }}
            />
            <div className="flex-1">
              <h3 className="font-semibold">{item?.variant?.product?.name || "Unknown Product"}, {item?.variant?.pack_size || ""}</h3>
              <p className="text-gray-500">{item?.quantity ?? "N/A"}</p>
              <p className="text-gray-500">{item?.variant?.pack_size === null || "" || undefined ? "" : item?.variant?.pack_size}</p>
              <p className="text-green-600 font-semibold">
                ₹{item?.variant?.discounted_price * item?.quantity ?? "N/A"}
                {item.variant?.price !== null && item.variant?.price !== undefined && (item?.variant?.discounted_price * item?.quantity !== item?.variant?.price * item?.quantity) && (
                  <span className="text-gray-500 line-through ml-2">₹{item?.variant?.price * item?.quantity}</span>
                )}
              </p>
            </div>
          </Link>
        ))}
      </div>
    );
  }



  return (
    <div className="bg-white py-12 px-4 lg:px-20 mt-20">
      <div className="container mx-auto">
        {isModalOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 relative z-50">
              <button
                className="absolute top-2 right-2 text-[40px] text-black-600 hover:text-black-900"
                onClick={toggleModal}
              >
                &times;
              </button>
              <h2 className="text-lg font-bold mb-4">Reason for Cancellation</h2>
              <form>
                {reasons.map((reason, index) => (
                  <div key={index} className="flex items-center mb-4 justify-between">
                    <label
                      htmlFor={reason.replace(/\s+/g, '')}
                      className="text-semibold underline cursor-pointer flex-1 text-left leading-6"
                    >
                      {reason}
                    </label>
                    <input
                      type="radio"
                      id={reason.replace(/\s+/g, '')}
                      name="cancellationReason"
                      value={reason}
                      checked={selectedReason === reason}
                      onChange={handleReasonChange}
                      className="ml-2"
                    />
                  </div>
                ))}
                {cancellationError && <p className="text-red-500 text-sm">{cancellationError}</p>}
                <button
                  type="button"
                  onClick={fetchUpdateStatus}
                  className="w-full bg-[#162C2A] text-white py-2 rounded hover:bg-green-700 mt-4"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Shipment Details */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:mt-1 mt-10">
          <div className="col-span-2">
            <h2 className="sm:text-lg sm:font-bold  text-base font-semibold  mb-2">Shipment Details</h2>
            <div className="border border-gray-300 rounded-2xl lg:p-8 p-4 mb-6">
              <div className="flex justify-between">
                <div>
                  <p className="text-sm text-gray-600">Order ID</p>
                  <p className="text-base font-poppins font-semibold">{order?.orderId || "N/A"}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-600">Placed On</p>
                  <p className="text-base font-poppins font-semibold">  {new Date(order?.created_at).toLocaleDateString() || "N/A"}</p>
                </div>
              </div>
            </div>

            {/* Delivery Progress */}
            <h2 className="sm:text-lg sm:font-bold  text-base font-semibold mb-2">Delivery Details</h2>
            {order?.delivery_status === "CANCELLED" && (
              <p className="text-gray-700 text-md font-poppins">
                <b>Cancellation Reason - </b> {order?.cancellation_reason || "Cancelled by User During Payment"}
              </p>
            )}


            {/* <div className="mt-8 flex flex-col md:flex-row items-center justify-center w-full"> */}
            <div className="relative w-full">
              {/* ✅ Desktop Layout */}
              <div className="w-full overflow-x-auto hidden lg:block md:block">
                <div className="flex justify-start items-center px-4 min-w-fit">
                  {displayedStatuses.map((status, index) => {
                    const completedStep = cancelled ? index < cancelledIndex : isCompletedStep(index);
                    const isCancelledStep = cancelled && index === cancelledIndex;
                    const isFirstStep = index === 0;
                    const isLastStep = index === displayedStatuses.length - 1;
                    const prevStepCompleted = index > 0 && isCompletedStep(index - 1);

                    return (
                      <div key={index} className="flex flex-col items-center text-center flex-1 min-w-[120px]">
                        {/* Date above dot */}
                        <p className={`text-gray-600 text-[13px] mb-2 whitespace-nowrap ${completedStep ? 'visible' : 'invisible'}`}>
                          {order?.updated_at ? (
                            <>
                              {new Date(order.updated_at).toLocaleTimeString()}
                              <br />
                              {new Date(order.updated_at).toLocaleDateString()}
                            </>
                          ) : "N/A"}
                        </p>

                        {/* Timeline */}
                        <div className="flex items-center w-full">
                          {/* Left Line */}
                          {!isFirstStep && (
                            <div className={`h-1 ${prevStepCompleted ? 'bg-green-900' : 'bg-gray-300'} flex-1`} />
                          )}

                          {/* Circle */}
                          <div className={`w-8 h-8 rounded-full border-2 flex items-center justify-center mx-1
                         ${isCancelledStep || completedStep ? 'bg-green-900 text-white' : 'bg-gray-300'}`}>
                            {isCancelledStep && (
                              <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.43 7.00172L13.496 2.93568C14.168 2.26373 14.168 1.1759 13.496 0.505677C12.8241 -0.164549 11.7363 -0.164549 11.066 0.505677L7 4.57172L2.93396 0.503959C2.26201 -0.167986 1.17419 -0.167986 0.503959 0.503959C-0.166268 1.1759 -0.166268 2.26373 0.503959 2.93396L4.57 7L0.503959 11.066C-0.167986 11.738 -0.167986 12.8258 0.503959 13.496C1.1759 14.1663 2.26373 14.1663 2.93396 13.496L7 9.43L11.066 13.496C11.738 14.168 12.8258 14.168 13.496 13.496C14.1663 12.8241 14.1663 11.7363 13.496 11.066L9.43 7V7.00172Z" fill="white" />
                              </svg>
                            )}
                          </div>

                          {/* Right Line */}
                          {!isLastStep && (
                            <div className={`h-1 ${completedStep ? 'bg-green-900' : 'bg-gray-300'} flex-1`} />
                          )}
                        </div>

                        {/* Label */}
                        <p className="text-gray-600 text-[13px] mt-2 capitalize text-center break-words">
                          {status.replace(/_/g, ' ')}
                        </p>
                      </div>
                    );
                  })}
                </div>
              </div>







              {/* ✅ Mobile Layout */}
              <div className="flex md:hidden flex-col w-full">
                {displayedStatuses.map((status, index) => {
                  const completedStep = isCompletedStep(index);
                  const isCancelledStep = order?.delivery_status === "CANCELLED" && index === lastStepIndex;
                  const isLastStep = index === displayedStatuses.length - 1;
                  const nextStepCompleted = index < displayedStatuses.length - 1 ? isCompletedStep(index + 1) : false;

                  return (
                    <div key={index} className="flex flex-row items-center justify-between mb-4">
                      {/* Updated Date - Left */}
                      <p className="text-gray-600 text-sm w-24">{order?.updated_at ? new Date(order.updated_at).toLocaleDateString() : "N/A"}</p>

                      {/* Timeline - Center */}
                      <div className="flex flex-col items-center">
                        {/* Circle */}
                        <div className={`w-10 h-10 flex items-center justify-center rounded-full border-2 
                        ${isCancelledStep ? 'bg-green-900 text-white' : completedStep ? 'bg-green-900 text-white' : 'bg-gray-300'}`}>
                          {isCancelledStep ? (
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9.43 7.00172L13.496 2.93568C14.168 2.26373 14.168 1.1759 13.496 0.505677C12.8241 -0.164549 11.7363 -0.164549 11.066 0.505677L7 4.57172L2.93396 0.503959C2.26201 -0.167986 1.17419 -0.167986 0.503959 0.503959C-0.166268 1.1759 -0.166268 2.26373 0.503959 2.93396L4.57 7L0.503959 11.066C-0.167986 11.738 -0.167986 12.8258 0.503959 13.496C1.1759 14.1663 2.26373 14.1663 2.93396 13.496L7 9.43L11.066 13.496C11.738 14.168 12.8258 14.168 13.496 13.496C14.1663 12.8241 14.1663 11.7363 13.496 11.066L9.43 7V7.00172Z" fill="white" />
                            </svg>
                          ) : ''}
                        </div>

                        {/* Vertical Line (Green if next step is completed, otherwise gray) */}
                        {!isLastStep && (
                          <div className={`h-12 w-1 ${nextStepCompleted ? 'bg-green-900' : 'bg-gray-400'}`}></div>
                        )}
                      </div>

                      {/* Available Status - Right */}
                      <p className="text-gray-600 text-sm w-24 text-right">{status.replace(/_/g, ' ')}</p>
                    </div>
                  );
                })}
              </div>


              {/* </div> */}

            </div>




            {/* {!isOrderCancelled && orderDetails.details[0].delivery_status !== "CANCELLED" && (
              <button
                onClick={toggleModal}
                className="w-full md:w-[150px] text-black font-semibold py-2 border-2 border-[#162c2a] rounded-xl hover:bg-gray-200 mt-6"
              >
                Order Cancel
              </button>
            )} */}


            {/* Items */}
            <h2 className="text-lg font-bold mt-8 mb-4">Items</h2>

            {order?.product && <ItemCard products={order.product} />}


          </div>

          {/* Shipment Summary */}
          <div className="col-span-1 ml-[20px]">
            <h2 className=" mb-2 text-right text-base font-semibold font-poppins">100% Secure payments</h2>
            <div className="border rounded-lg p-6 w-full  ">
              <h2 className="text-base font-semibold font-poppins  mb-4">Shipment Summary</h2>

              {order?.bill?.length > 0 ? (
                <>
                  {order.bill.map((billItem, index) => (
                    <div key={index}>
                      <div className="flex justify-between mb-2">
                        <span className="text-gray-600">MRP</span>
                        <span className="font-semibold font-poppins text-base">₹{billItem.mrp}</span>
                      </div>
                      <div className="flex justify-between mb-2 text-green-600">
                        <span>Discount</span>
                        <span className='font-semibold font-poppins text-base'>₹{billItem.discount}</span>
                      </div>

                      <div className="flex justify-between mb-2">
                        <span className="text-gray-600">Delivery Fees</span>
                        <span className="font-semibold">free</span>
                      </div>
                      <div className="flex justify-between border-t pt-4 gap-4">
                        <span className="font-medium flex whitespace-nowrap font-poppins text-base">Amount Paid</span>
                        <span className="font-semibold font-poppins text-base">₹{billItem.totalAmount}</span>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <p className="text-red-500">No bill details available.</p>
              )}
            </div>

            <div className="flex items-center mt-6">
              <img className="lg:w-[35px] lg:h-[30px] w-[25px] h-[25px]" src={helpicon} alt="Help Icon" />
              <span className="ml-2 font-semibold">Need help?</span>
            </div>

            <Link to="/faq">
              <button className="w-full bg-gray-100 text-black font-semibold py-2 rounded-lg mt-2 hover:bg-gray-200">
                FAQs & More
              </button>
            </Link>
          </div>


        </div>
      </div>
    </div>
  );
};

export default Orderdetails;
